import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { PageView } from '@jg/react-tracking';

import MemberCardList from '../../components/MemberCard/MemberCardList';
import MembershipPolicyForm from './MembershipPolicyForm';
import ManageMembersTarget from './ManageMembersTarget';
import InviteMembers from '../../components/InviteMembers/InviteMembers';

export const EditMembers = () => {
  const { t } = useTranslation();
  return (
    <PageView
      trackingData={{
        subtype: 'admin',
        event_value: 'members',
        page_section: 'admin > members',
      }}
    >
      <Helmet title={t('title.editMembers')} />
      <main className="jg-space-ptml">
        <h1 className="jg-hidden-visually">{t('content.admintabs.members')}</h1>
        <section>
          <MembershipPolicyForm />
        </section>
        <section>
          <ManageMembersTarget />
        </section>
        <section>
          <h1 className="jg-space-mbn jg-h3 ">
            {t('content.editmembers.teamMembersTitle')}
          </h1>
          <InviteMembers />
          <MemberCardList />
        </section>
      </main>
    </PageView>
  );
};

export default EditMembers;
